module.exports = __webpack_public_path__ + "static/media/salesforce2x.b6972ed9.png";